import { Post } from './Chat/Post';
import { PostList } from './Chat/PostList';

export * from './Function/Type';
export * from './Functions';
export * from './Chat/Post';


export interface Function<T extends Post> {
  readonly id: string;
  readonly name: string;
  readonly type: string;
  readonly postList: PostList<T>;
  readonly lastupdate: Date;
  addThread(threadFirstPost: T): void;
  hasChildren(): boolean;
  update(): void;
  toPlainObject(): Object;
}
